export default __webpack_public_path__ + "static/media/attila-in-cone.6458ef74.png";